import { useMemo } from "react";

import type { SavedFiltersEndpoint } from "@js/apps/common/components/save-filters/const";
import { SAVED_FILTERS_ENDPOINT } from "@js/apps/common/components/save-filters/const";
import { useGetSavedTalentFiltersQuery } from "@js/apps/freelancer/api";
import { useGetSavedJobFiltersQuery } from "@js/apps/jobs/api";
import { useAppSelector } from "@js/hooks";

export const useGetActiveFilterName = (
  location: string,
  endpoint: SavedFiltersEndpoint,
) => {
  const savedFilterName = useAppSelector(
    (state) => state.savedFilters.savedFilterName,
  );
  const { data: filtersJobs = [] } = useGetSavedJobFiltersQuery(undefined, {
    skip: endpoint !== SAVED_FILTERS_ENDPOINT.JOBS,
  });
  const { data: filtersTalents = [] } = useGetSavedTalentFiltersQuery(
    undefined,
    { skip: endpoint !== SAVED_FILTERS_ENDPOINT.TALENTS },
  );
  const loadedFilters = useMemo(
    () =>
      [...filtersTalents, ...filtersJobs].find(
        (f) => f.name === savedFilterName[location],
      )?.filters,
    [filtersTalents, filtersJobs, savedFilterName, location],
  );
  return {
    savedFilterName: savedFilterName[location],
    loadedFilters,
  };
};
